// Entry point for the build script in your package.json
import { Application } from '@hotwired/stimulus'
import controllers from './*_controller.js'


const application = Application.start()

// Configure Stimulus development experience
application.debug = true
window.Stimulus = application

controllers.forEach((controller) => {
  application.register(controller.name, controller.module.default)
})

// Debug: Log all registered controllers
console.log('Registered Stimulus controllers:', controllers.map(c => c.name))

// Check if task-execution controller is registered
const hasTaskExecution = controllers.some(c => c.name === 'task-execution')
console.log('task-execution controller registered:', hasTaskExecution)

// Debug: Check if our DevTools controllers are being found
const devtoolsControllers = ['preview-devtools', 'console-log', 'devtools-cable', 'network-monitor', 'dom-inspector', 'performance-metrics', 'error-tracker']
devtoolsControllers.forEach(name => {
  const found = controllers.some(c => c.name === name)
  console.log(`DevTools controller "${name}": ${found ? 'FOUND' : 'MISSING'}`)
})

// Also log if claude-code-chat-ruby is included
const hasRubyChat = controllers.some(c => c.name === 'claude-code-chat-ruby')
console.log('claude-code-chat-ruby controller found:', hasRubyChat)

// Check for workflow-execution controller
const hasWorkflowExecution = controllers.some(c => c.name === 'workflow-execution')
console.log('workflow-execution controller found:', hasWorkflowExecution)
